var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}},[_vm._v(_vm._s(_vm.$t('rodape.aguardeCarregando')))]),_c('v-btn',{staticClass:"no-print",on:{"click":_vm.imprimir}},[_vm._v(_vm._s(_vm.$t("rodape.imprimir")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }